<ng-container *ngIf='direction === "asc"'><i-bs class="sort-icon" name="chevron-up"></i-bs></ng-container><ng-container *ngIf='direction === "desc"'><i-bs class="sort-icon" name="chevron-down"></i-bs></ng-container>
